import { useCallback } from 'react';

import {
  FEATURE,
  HOLDS_AND_CHECKOUTS_TABS,
  HoldsAndCheckoutsTab,
  ROUTE,
} from '@app/constants';

import { useFeatureFlag } from './useFeatureFlag';

export type SelectConfiguredOption = <RequestsOption, HoldsOption>(
  requestAndLoansOption: RequestsOption,
  holdsAndCheckoutsOption: HoldsOption
) => RequestsOption | HoldsOption;

export const useHoldsAndCheckoutsPageConfig = () => {
  const { config = {} } = useFeatureFlag({
    name: FEATURE.holdsAndCheckouts,
  });

  const selectConfiguredOption: SelectConfiguredOption = useCallback(
    (requestAndLoansOption, holdsAndCheckoutsOption) =>
      config.isRequestsAndLoans
        ? requestAndLoansOption
        : holdsAndCheckoutsOption,
    [config.isRequestsAndLoans]
  );

  const parentRoute = selectConfiguredOption(
    ROUTE.requestsAndLoans,
    ROUTE.holdsAndCheckouts
  );

  const getTabRoute = useCallback(
    (tabName: HoldsAndCheckoutsTab): ROUTE => {
      const tabRoutes = config.isRequestsAndLoans
        ? {
            [HOLDS_AND_CHECKOUTS_TABS.holds]: ROUTE.requests,
            [HOLDS_AND_CHECKOUTS_TABS.checkouts]: ROUTE.loans,
            [HOLDS_AND_CHECKOUTS_TABS.fees]: ROUTE.fees,
          }
        : ROUTE;
      const tabRoute = tabRoutes[tabName];

      return `${parentRoute}${tabRoute}` as ROUTE;
    },
    [parentRoute, config.isRequestsAndLoans]
  );

  return {
    holdsAndCheckoutsRoute: parentRoute,
    selectConfiguredOption,
    getTabRoute,
  };
};
